import { BRANCH_STATE_KEY, BranchState } from './branch-reducer';

export enum BRANCH_ACTION_TYPE {
  SET_BRANCH_STATE = 'SET_BRANCH_STATE',
  CALL_BRANCH = 'CALL_BRANCH',
  CALL_VAT = 'CALL_VAT',
}

export type SetBranchStateAction<KeyName extends keyof BranchState> = {
  type: BRANCH_ACTION_TYPE.SET_BRANCH_STATE;
  payload: { key: KeyName, value: BranchState[KeyName] };
};


export type BranchActions = SetBranchStateAction<BRANCH_STATE_KEY>;
